export function googleMap() {
    let mapStyle = [
        {
            "featureType": "administrative",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#444444"
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [
                {
                    "color": "#f2f2f2"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "all",
            "stylers": [
                {
                    "saturation": -100
                },
                {
                    "lightness": 45
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "simplified"
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "all",
            "stylers": [
                {
                    "color": "#46bcec"
                },
                {
                    "visibility": "on"
                }
            ]
        }
    ];
    let map = new google.maps.Map(document.getElementById("map"), {
        styles: mapStyle,
        zoom: 9,
        scrollwheel: false,
        scaleControl: false,
        draggable: !(typeof window.orientation !== "undefined" || navigator.userAgent.indexOf("IEMobile") !== -1),
        zoomControl: false,
        disableDoubleClickZoom: true,
        panControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        overviewMapControl: false,
        fullscreenControl: false,
        center: {lat: 28.5471694, lng: -81.38010498}
    });
    let marker = new google.maps.Marker({
        position: map.getCenter(),
        icon: "https://iaac-dev.bigdropinc.net/wp-content/themes/bigdrop-theme/dist/images/pin.png",
        map: map
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/googleMap.js